// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Form, TextArea } from 'informed';
import moment from 'moment';

import {
  addSymptomAnalysis,
  updateSymptomAnalysis,
} from '../../../../actions/progressNoteActions';

import { PrimaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import { Button, PrimaryButton } from '../../../Buttons.jsx';
import DatetimeText from '../../../DatetimeText.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  note: ?Object,
  /*
    (noteId: string, note: Object) => {}
  */
  handleSaveNote: Function,
  /*
    (note: Object) => {}
  */
  handleSaveNewNote: Function,
  activePatientId: string,
  activeAccount: Object,
  problemId: string,
  closePage: Function,
}

class EditSymptomAnalysisComponent extends React.Component<Props> {
  formApi: {
    getState: Function,
    reset: Function,
  }

  setFormApi = (formApi: Object) => {
    this.formApi = formApi;
  }

  // Misc functions
  /* eslint-disable no-param-reassign */
  transformData(formValues: Object) {
    formValues.date = moment(formValues.date, 'DD-MM-YYYY, HH:mm').toISOString();
    // add active account for edit history
    const { activeAccount } = this.props;
    formValues.editor = `${activeAccount.name}, ${activeAccount.credential}`;
    formValues.editDate = moment().toISOString();
  }

  handleSave = () => {
    const formData = this.formApi.getState();
    if (formData.invalid) {
      return;
    }
    if (!Object.keys(formData.touched).length) {
      this.props.closePage();
      return;
    }
    this.transformData(formData.values);
    if (!this.props.note) {
      this.props.handleSaveNewNote(this.props.activePatientId, {
        problemId: this.props.problemId,
        ...formData.values,
      });
    } else {
      this.props.handleSaveNote(this.props.activePatientId, {
        progressNoteId: this.props.note._id,
        ...formData.values,
      });
    }
    this.props.closePage();
  }

  render() {
    const data = this.props.note || {};
    const { editors, editDates } = data;
    let editHistory = '';
    if (editors) {
      for (let i = 0; i < editors.length; i++) {
        if (i === editors.length - 1) {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]} (created) \n`;
        } else {
          editHistory += `${moment(editDates[i]).format('DD-MM-YYYY, HH:mm')} - ${editors[i]}\n`;
        }
      }
    }

    return (
      <ContentBox title='Symptom Analysis'>
        <Form getApi={this.setFormApi} autoComplete='off'>
          <div className={styles.notes}>
            <PrimaryText>Chief Complaint</PrimaryText><br />
            <TextArea field='complaint' initialValue={data.complaint} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Onset</PrimaryText><br />
            <TextArea field='onset' initialValue={data.onset} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Location</PrimaryText><br />
            <TextArea field='location' initialValue={data.location} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Duration</PrimaryText><br />
            <TextArea field='duration' initialValue={data.duration} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Characteristics</PrimaryText><br />
            <TextArea field='characteristics' initialValue={data.characteristics} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Aggravating Factors</PrimaryText><br />
            <TextArea field='aggravatingFactors' initialValue={data.aggravatingFactors} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Relieving Factors</PrimaryText><br />
            <TextArea field='relievingFactors' initialValue={data.relievingFactors} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Treatment</PrimaryText><br />
            <TextArea field='treatment' initialValue={data.treatment} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Associated Signs and Symptoms</PrimaryText><br />
            <TextArea field='signsSymptoms' initialValue={data.signsSymptoms} />
          </div>
          <div className={styles.notes}>
            <PrimaryText>Notes</PrimaryText><br />
            <TextArea field='notes' initialValue={data.notes} />
          </div>
          <table>
            <tbody>
              <tr>
                <td><PrimaryText>Exam Date </PrimaryText></td>
                <td><DatetimeText field='date' initialValue={data.date} /></td>
              </tr>
              <tr className={styles.editHistoryRow}>
                <td><strong>Edit History </strong></td>
                <td>{editHistory || '--'}</td>
              </tr>
            </tbody>
          </table>
          <PrimaryButton onClick={this.handleSave}>Save</PrimaryButton>
          <Button onClick={this.props.closePage}>Cancel</Button>
        </Form>
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  activePatientId: state.patient.data.activePatientId,
  activeAccount: state.account.activeAccount,
});

const mapDispatchToProps = dispatch => ({
  handleSaveNewNote:
   (patientId, symptomAnalysis) => dispatch(addSymptomAnalysis(patientId, symptomAnalysis)),
  handleSaveNote:
   (patientId, symptomAnalysis) => dispatch(updateSymptomAnalysis(patientId, symptomAnalysis)),
});

const EditSymptomAnalysis = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditSymptomAnalysisComponent);

export default EditSymptomAnalysis;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/edit/EditSymptomAnalysis.jsx